import React from "react";
import { Button, Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { helpUrlForRoute } from "../../../../constants/helpRouteMap";

type Props = {
  onStart: () => void;
};

/**
 * LAC-004 — primeiro acesso: 1 CTA + link de ajuda (sem jargão DNS).
 */
const SendingSetupEmptyState = ({ onStart }: Props) => {
  const { t, i18n } = useTranslation();
  const helpHref = helpUrlForRoute("/settings/sending", i18n.language || "pt-BR");

  return (
    <Card className="border-0 shadow-none">
      <CardBody className="text-center py-5 px-4">
        <div className="avatar-lg mx-auto mb-3">
          <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-1">
            <i className="ri-mail-send-line" />
          </div>
        </div>
        <h4 className="mb-2">{t("settings.sending.empty.title")}</h4>
        <p className="text-muted mb-4 mx-auto" style={{ maxWidth: 480 }}>
          {t("settings.sending.empty.description")}
        </p>
        <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center align-items-center">
          <Button color="primary" onClick={onStart}>
            {t("settings.sending.empty.cta")}
          </Button>
          <a
            href={helpHref}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-link"
          >
            {t("settings.sending.empty.help")}
            <i className="ri-external-link-line ms-1 align-middle" />
          </a>
        </div>
      </CardBody>
    </Card>
  );
};

export default SendingSetupEmptyState;
